<template></template>

<script>
import {mapActions, mapMutations} from "vuex";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";

export default {

	async mounted ()
	{
		this.load();

		EventBus.$on(Event.CUSTOMER_LOGIN, () => this.load());
		EventBus.$on(Event.APPLICATION_LOGIN, () => this.load());
		EventBus.$on(Event.CUSTOMER_SESSION_EXPIRED, () => this.load());
		EventBus.$on(Event.APPLICATION_SESSION_EXPIRED, () => this.load());
	},

	methods: {
		...mapMutations('auth', [
			'setApplication',
			'setCustomer',
			'setLoaded',
		]),
		...mapActions('auth', [
			'load',
		]),
	}
}
</script>
